module.exports = __webpack_public_path__ + "img/benefit_business.a25ea814.jpeg";